import { AuthLayout } from "./layouts/authLayout";
import { ErrorView } from "./components/errorView";
import { EmailView } from "./components/emailView";
import type { RouteObject } from "react-router-dom";
import { VerifyView } from "./components/verifyView";
import { PreviewView } from "./components/previewView";
// import { ReviewInfoView } from "./components/ReviewInfoView/reviewView";
// import { SubmittedView } from "./components/SubmittedView/submittedView";
// import { DocumentsView } from "./components/DocumentsView/documentsView";
import { MortgageApplicationLayout } from "./layouts/mortgageApplication";
// import { ConfirmationView } from "./components/ConfirmationView/confirmationView";
import { CreditConsentView } from "./components/CreditConsentView/creditConsentView";
// import { PendingContactView } from "./components/pendingContactView/pendingContactView";
import { CoApplicantsDetailsView } from "./components/CoApplicantsView/coApplicantsView";
import { EmploymentDetailsView } from "./components/EmploymentDetailsView/employmentDetailsView";
import { PersonalInformation } from "./components/PersonalInformationView/personalInformationView";
import { DownPaymentDetailsView } from "./components/DownPaymentDetailsView/downPaymentDetailsView";

export const routes = (): RouteObject[] => {
  return [
    {
      path: "/",
      element: <AuthLayout type="private" />,
      errorElement: <ErrorView />,
      children: [
        {
          path: "/",
          element: <MortgageApplicationLayout />,
          errorElement: <ErrorView />,
          children: [
            {
              path: "/",
              element: <PersonalInformation />,
              errorElement: <ErrorView />,
            },

            {
              path: "/employment-details",
              element: <EmploymentDetailsView />,
              errorElement: <ErrorView />,
            },

            {
              path: "/co-applicants",
              element: <CoApplicantsDetailsView />,
              errorElement: <ErrorView />,
            },

            {
              path: "/down-payment",
              element: <DownPaymentDetailsView />,
              errorElement: <ErrorView />,
            },
            {
              path: "/credit-consent",
              element: <CreditConsentView />,
              errorElement: <ErrorView />,
            },
            // {
            //   path: "/review-info",
            //   element: <ReviewInfoView />,
            //   errorElement: <ErrorView />,
            // },
            // {
            //   path: "/confirmation",
            //   element: <ConfirmationView />,
            //   errorElement: <ErrorView />,
            // },
            // {
            //   path: "/documents",
            //   element: <DocumentsView />,
            //   errorElement: <ErrorView />,
            // },
            // {
            //   path: "/submitted",
            //   element: <SubmittedView />,
            //   errorElement: <ErrorView />,
            // },
            // {
            //   path: "/pending-contact",
            //   element: <PendingContactView />,
            //   errorElement: <ErrorView />,
            // },
          ],
        },
      ],
    },
    {
      path: "/login",
      element: <AuthLayout type="public" />,
      errorElement: <ErrorView />,
      children: [
        {
          path: "",
          element: <PreviewView />,
          errorElement: <ErrorView />,
        },
        {
          path: "email",
          element: <EmailView />,
          errorElement: <ErrorView />,
        },
        {
          path: "verify",
          element: <VerifyView />,
          errorElement: <ErrorView />,
        },
      ],
    },
  ];
};
